var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper", staticStyle: { "min-width": "1300px" } },
    [
      _c("div", { staticClass: "right-block" }, [
        _c(
          "div",
          { staticClass: "login-container" },
          [
            _c("img", {
              staticStyle: { width: "120px", height: "120px" },
              attrs: { src: require("../../assets/image/jz-logo.png") }
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "loginForm",
                staticClass: "login-form",
                attrs: {
                  model: _vm.loginForm,
                  rules: _vm.loginRules,
                  "auto-complete": "on",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "username" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        name: "username",
                        type: "text",
                        tabindex: "1",
                        "auto-complete": "on",
                        placeholder: "请输入登录账号",
                        clearable: ""
                      },
                      model: {
                        value: _vm.loginForm.username,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "username", $$v)
                        },
                        expression: "loginForm.username"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "password" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: _vm.passwordType,
                        name: "password",
                        "auto-complete": "on",
                        tabindex: "2",
                        "show-password": "",
                        placeholder: "请输入登录密码",
                        clearable: ""
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleLogin($event)
                        }
                      },
                      model: {
                        value: _vm.loginForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "password", $$v)
                        },
                        expression: "loginForm.password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { prop: "verifyCode" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "flex-direction": "row" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          name: "verifyCode",
                          type: "text",
                          tabindex: "3",
                          "auto-complete": "on",
                          placeholder: "请输入验证码",
                          clearable: ""
                        },
                        model: {
                          value: _vm.loginForm.verifyCode,
                          callback: function($$v) {
                            _vm.$set(_vm.loginForm, "verifyCode", $$v)
                          },
                          expression: "loginForm.verifyCode"
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          id: "code",
                          width: "130px",
                          height: "48px",
                          alt: "加载中"
                        },
                        on: { click: _vm.getCaptcha }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "svg-container" },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "verifyCode" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%", margin: "20px 0" },
                    attrs: { loading: _vm.loading, type: "primary" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleLogin($event)
                      }
                    }
                  },
                  [_vm._v("登录")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(1)
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-title" }, [
      _c("p", [
        _vm._v("欢迎登录"),
        _c("span", { staticStyle: { color: "#671E75" } }, [
          _vm._v(" a2工单系统V2.02")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-company" }, [
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c("div", { staticClass: "compangy-name" }, [
        _vm._v(
          "© Copyright 2024 All rights reserved by The a2 Milk Company Limited"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }